import createLendingBundle from './createBundle'
import whitepaper from './whitepaper.fr'

export default createLendingBundle(whitepaper)
